import { render } from "./NeverSearch.vue?vue&type=template&id=6658a3b2&scoped=true"
const script = {}

import "./NeverSearch.vue?vue&type=style&index=0&id=6658a3b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6658a3b2"]])

export default __exports__